
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M208 0C93.312 0 0 93.312 0 208v192c0 6.464 3.904 12.32 9.888 14.784 1.984.8 4.064 1.216 6.112 1.216 4.16 0 8.256-1.632 11.328-4.672l45.408-45.44C110.464 398.304 157.92 416 208 416c114.688 0 208-93.312 208-208S322.688 0 208 0z"}}),_c('path',{attrs:{"d":"M445.44 174.976C446.944 185.792 448 196.768 448 208c0 132.352-107.648 240-240 240-11.072 0-22.048-.928-32.928-2.432C210.304 486.176 262.144 512 320 512c45.856 0 89.248-16.032 123.904-45.472l40.768 40.768A16.019 16.019 0 00496 512c2.048 0 4.16-.416 6.112-1.216C508.096 508.32 512 502.464 512 496V320c0-57.92-25.888-109.792-66.56-145.024z"}})])
          )
        }
      }
    